const login = {
    es: 'Iniciar sesión',
	en: 'Login',
	pt: 'Conecte-se',
}

const contactUs = {
    es: 'Contáctanos',
	en: 'Contact us',
	pt: 'Contate-nos',
}

const returnHome = {
    es: 'Volver a la página de inicio',
	en: 'Back to home page',
	pt: 'Voltar para a página inicial',
}

export { login, contactUs, returnHome };